import { GET_PRESIGNED_URL, GET_PRESIGNED_URL_SUCCESS, GET_PRESIGNED_URL_ERROR, GET_PRESIGNED_URL_EMPTY } from '../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetPresignedUrl = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRESIGNED_URL:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_PRESIGNED_URL_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_PRESIGNED_URL_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_PRESIGNED_URL_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetPresignedUrl;
